
import { Box, IconButton, Tooltip, Typography } from "@mui/material"
import { getterTime, renderCellTimeWithFileDrop } from "branch/pages/ShippingProcess/columns"
import { shippingInvoiceColNm } from "branch/pages/ShippingProcess/constant"
import { BoxFR } from "components/BoxCustom"
import dayjs from "dayjs"
import { ReplyRounded } from "resource/muiImport"
import { shippingColumnsEnd } from "./shippingColumnsEnd"
import { shippingColumnsStart } from "./shippingColumnsStart"


// ------------------------------------------------------------------------------------------------------------------
// ------------------------------------------------------Export Columns------------------------------------------------------
// ------------------------------------------------------------------------------------------------------------------
export const shippingProcessExportColumns = ({ handleFileClick, handlePrintDriver, handleUpdateTime
  , handleDeleteTime, onFileUploadSuccess, handlePrintExpense, handleUpdateETA }) => [
    ...shippingColumnsStart({ handleUpdateETA }),
  {
    field: 'BLRecvTm',
    cellClassName: "normal-col",
    headerName: "เวลารับ Booking",
    width: 170,
    type: 'dateTime',
    editable: true,
    valueGetter: getterTime,
    valueFormatter: (params) => params.value ? dayjs(params.value).format("DD/MM HH:mm") : "-",
    renderCell: (params) => renderCellTimeWithFileDrop(params, handleUpdateTime, handleDeleteTime, onFileUploadSuccess, 8)
  },
  {
    field: 'FormTm',
    cellClassName: "normal-col",
    headerName: shippingInvoiceColNm.FormTm,
    width: 170,
    type: 'dateTime',
    editable: true,
    valueGetter: getterTime,
    valueFormatter: (params) => params.value ? dayjs(params.value).format("DD/MM HH:mm") : "-",
    renderCell: (params) => renderCellTimeWithFileDrop(params, handleUpdateTime, handleDeleteTime, onFileUploadSuccess, 8)
  },
  // {
  //   field: 'Doc1Tm',
  //   cellClassName: "normal-col",
  //   headerName: shippingInvoiceColNm.Doc1Tm,
  //   width: 170,
  //   type: 'dateTime',
  //   editable: true,
  //   valueGetter: getterTime,
  //   valueFormatter: (params) => params.value ? dayjs(params.value).format("DD/MM HH:mm") : "-",
  //   renderCell: (params) => renderCellTimeWithFileDrop(params, handleUpdateTime, handleDeleteTime, onFileUploadSuccess, 8)
  // },
  // {
  //   field: 'Doc2Tm',
  //   cellClassName: "normal-col",
  //   headerName: shippingInvoiceColNm.Doc2Tm,
  //   width: 170,
  //   type: 'dateTime',
  //   editable: true,
  //   valueGetter: getterTime,
  //   valueFormatter: (params) => params.value ? dayjs(params.value).format("DD/MM HH:mm") : "-",
  //   renderCell: (params) => renderCellTimeWithFileDrop(params, handleUpdateTime, handleDeleteTime, onFileUploadSuccess, 8)
  // },
  // {
  //   field: 'DocSndTm',
  //   cellClassName: "normal-col",
  //   headerName: shippingInvoiceColNm.DocSndTm,
  //   width: 170,
  //   type: 'dateTime',
  //   editable: true,
  //   valueGetter: getterTime,
  //   valueFormatter: (params) => params.value ? dayjs(params.value).format("DD/MM HH:mm") : "-",
  //   renderCell: (params) => renderCellTime(params, handleUpdateTime, handleDeleteTime, onFileUploadSuccess)
  // },
  {
    field: 'ED0209CreTm',
    cellClassName: "normal-col",
    headerName: shippingInvoiceColNm.ED0209CreTm,
    width: 170,
    type: 'dateTime',
    editable: true,
    valueGetter: getterTime,
    valueFormatter: (params) => params.value ? dayjs(params.value).format("DD/MM HH:mm") : "-",
    renderCell: (params) => renderCellTimeWithFileDrop(params, handleUpdateTime, handleDeleteTime, onFileUploadSuccess, 14)
  },
  // {
  //   field: 'CDCreTm',
  //   cellClassName: "normal-col",
  //   headerName: shippingInvoiceColNm.CDCreTm,
  //   width: 170,
  //   type: 'dateTime',
  //   editable: true,
  //   valueGetter: getterTime,
  //   valueFormatter: (params) => params.value ? dayjs(params.value).format("DD/MM HH:mm") : "-",
  //   renderCell: (params) => renderCellTimeWithFileDrop(params, handleUpdateTime, handleDeleteTime, onFileUploadSuccess, 14)
  // },
  // {
  //   field: 'ED0409CreTm',
  //   cellClassName: "normal-col",
  //   headerName: shippingInvoiceColNm.ED0409CreTm,
  //   width: 170,
  //   type: 'dateTime',
  //   editable: true,
  //   valueGetter: getterTime,
  //   valueFormatter: (params) => params.value ? dayjs(params.value).format("DD/MM HH:mm") : "-",
  //   renderCell: (params) => renderCellTimeWithFileDrop(params, handleUpdateTime, handleDeleteTime, onFileUploadSuccess, 14)
  // },
  // {
  //   field: 'PayCstmTm',
  //   cellClassName: "normal-col",
  //   headerName: shippingInvoiceColNm.PayCstmTm,
  //   width: 170,
  //   type: 'dateTime',
  //   editable: true,
  //   valueGetter: getterTime,
  //   valueFormatter: (params) => params.value ? dayjs(params.value).format("DD/MM HH:mm") : "-",
  //   renderCell: (params) => renderCellTimeWithFileDrop(params, handleUpdateTime, handleDeleteTime, onFileUploadSuccess, 14)
  // },
  {
    field: 'FrtInvTm',
    cellClassName: "normal-col",
    headerName: shippingInvoiceColNm.FrtInvTm,
    width: 170,
    type: 'dateTime',
    editable: true,
    valueGetter: getterTime,
    valueFormatter: (params) => params.value ? dayjs(params.value).format("DD/MM HH:mm") : "-",
    renderCell: (params) => renderCellTimeWithFileDrop(params, handleUpdateTime, handleDeleteTime, onFileUploadSuccess, 10)
  },
  {
    field: 'AptTm',
    cellClassName: "normal-col",
    headerName: 'วันที่นัดเข้า รง.',
    width: 120,
    type: 'dateTime',
    valueGetter: getterTime,
    // valueFormatter: (params) => params.value ? dayjs(params.value).format("DD/MM HH:mm") : "-",
    renderCell: (params) => {
      return (
        <BoxFR sx={{ width: "100%", gap: 0 }}>
          <Typography variant='body2' >{params.value ? dayjs(params.value).format("DD/MM HH:mm") : "-"}</Typography>
          <Box flexGrow={1} />
          <Tooltip title="ไปที่หน้า 1.3" placement='top' followCursor>
            <IconButton sx={{ p: 0, m: 0 }} onClick={() => {
              var win = window.open(window.location.origin + `/emily/DailyJob/ShpmId/${params.row.ShpmId}`, '_blank');
              win.focus();
            }}>
              <ReplyRounded sx={{ transform: "scaleX(-1)" }} />
            </IconButton>
          </Tooltip>
        </BoxFR>
      )
    }
  },
  ...shippingColumnsEnd({ handleFileClick, handlePrintDriver, handleUpdateTime
  , handleDeleteTime, onFileUploadSuccess, handlePrintExpense })
]